module.exports = __webpack_public_path__ + "static/media/26UNRWA8.cb377e10.jpg";